$(function () {

    var $oc = $('.org-chart-content');

    var orgChartFeed = null;
    try {
        orgChartFeed = JSON.parse($('#org-chart-feed').html());
    } catch (e) {
        console.error('Org Chart not found!')
    }

    if (orgChartFeed) {
        var template = $('#oc-template-item').html();

        var root = orgChartFeed.root;
        root.index = -1;
        root.type = 'root';

        var branches = orgChartFeed.branches;

        var $root = $('.org-chart-root'),
            $branches = $('.org-chart-branches');

        $root.html(processTemplate(template, root));
        $branches.html(
            branches.map(function (p, i) {
                p.index = i;
                p.type = 'branch';
                return processTemplate(template, p);
            }).join('')
        );

    } else {
        $oc.html('<div class="alert alert-warning">Sorry, Org Chart is not found!</div>');
    }

    function processTemplate(template, options) {
        var checkNotOperator = function (bool) {
            var flip = false;
            if (bool.charAt(0) === '!') {
                bool = bool.substring(1);
                flip = true;
            }
            var shouldOutput = options[bool];
            return flip ? !shouldOutput : shouldOutput;
        };
        return template
            .replace(/{{#if (.*?)}}((.|\n|\r)*?){{\/if}}/gm, function (match, bool, content) {
                return checkNotOperator(bool) ? content : '';
            })
            .replace(/{{(.*?)}}/gm, function (match, content) {
                return (typeof options[content] === 'undefined') ? match : options[content];
            });
    }
});
